<template>
<div>
  <BaseFrame
  cancelText=''
  clearText=''
  :printText="btnText"
  @print='toWatchBackTMOrder'
  >
    <div class="container" slot="content">
      <div class="tableContainer">
        <lk-card v-if="isSelectOrderType">
          <div style="display:flex;align-items:center;">
            <div>订单类型：</div>
            <lk-radio-group v-model="orderType">
              <lk-radio :label='2' :disabled="isDisableOrderType">配送订单</lk-radio>
              <lk-radio :label='1' :disabled="isDisableOrderType">自提订单</lk-radio>
            </lk-radio-group>
          </div>
        </lk-card>
        <lk-card >
        <goods-table
          @change="handleChange"
          v-model="saleData.saleOrderDetailList"
          @handlerPatientRebuy='handlerPatientRebuy'
          :purchaseType='saleData.purchaseType'
          :errArr='errArr'
          :epInfo='saleData.ep'
          :epDetailPrice='epDetailPrice'
          @getDataLink='getDataLink'
        ></goods-table>
        </lk-card>
      </div>
      <div class="middleContainer">
        <div  v-if="needBuyerInfo" style='width:25%;'>
             <lk-card title="购买者信息">
            <div>
               <lk-form ref="buyer" :label-width="90" :model='saleData.saleBuyerInfo'
            :rules='saleBuyerInfo'>
            <lk-form-item label="购药者姓名:" prop="buyerName">
              <lk-input :maxlength='30'
                placeholder='请输入' v-model="saleData.saleBuyerInfo.buyerName"></lk-input>
            </lk-form-item>
            <lk-form-item label="购药者年龄:" prop="buyerAge">
              <lk-input :maxlength='4'
                placeholder='请输入' v-model="saleData.saleBuyerInfo.buyerAge" number></lk-input>
            </lk-form-item>
            <lk-form-item label="性别:" prop="buyerGender">
              <lk-radio-group ref="buyer2"
                v-model="saleData.saleBuyerInfo.buyerGender">
                <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">
                  <span>{{item}}</span>
                </lk-radio>
              </lk-radio-group>
            </lk-form-item>
            <lk-form-item label="身份证号码:" prop="buyerIdCard">
                <CredentialsInput  v-model="saleData.saleBuyerInfo" @setRules='setRules' codeKey="buyerIdCard" typeKey="permissionType"></CredentialsInput>
            </lk-form-item>

            <lk-form-item label="联系方式:" prop="buyerPhone">
              <lk-input :maxlength='50'
                placeholder='请输入' v-model="saleData.saleBuyerInfo.buyerPhone"></lk-input>
            </lk-form-item>
            <lk-form-item label="购买原因:" prop="buyerReason">
              <lk-input :maxlength='100'
                placeholder='请输入' v-model="saleData.saleBuyerInfo.buyerReason"></lk-input>
            </lk-form-item>
          </lk-form>
            </div>

          </lk-card>
        </div>
        <div v-if="saleData.salePrescription" style='width:100%'>
          <prescriptionDecoction v-if='saleData.retailType===3' ref="prescriptionInfo" v-model="saleData.salePrescription"
            :able='false'></prescriptionDecoction>
          <prescriptionCommon v-else
          ref="prescriptionInfo"
          v-model="saleData.salePrescription"
          :able="ifCanEdit"
          :isPatientRebuy='isPatientRebuy'
          :ablePharmacistList='true'
          :isPrescription='true'
          :saleOrderDetailList="saleData.saleOrderDetailList"
          :pharmacistList='pharmacistList'
          :isContainDataDirectGoods='isContainDataDirectGoods'
          :diseaseList="diseaseList"
          :dataLink="dataLink">
          </prescriptionCommon>
        </div>
      </div>
    <div v-if="isExpressOrder && isNeedUseUnifyExpress && orderType === 2">
      <lk-card title="配送信息">
        <lk-form
          :label-width='132'
          ref="deliverInfo"
          :model="deliverInfo"
          :rules="deliverInfoValidate"
        >
          <lk-row type="flex">
            <lk-col span="6">
              <lk-form-item label="配送方式：" prop="deliveryMethod">
                <lk-select placeholder="请选择" v-model='deliverInfo.deliveryMethod' :label='deliveryMethodName'>
                  <lk-option v-for="(item, i) in deliverList"  :value='item.value' :key="item.value">
                  {{item.label}}
                  </lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="发货时间：" prop="expressTime">
                <timeStampDatePicker  v-model="deliverInfo.expressTime"></timeStampDatePicker>
              </lk-form-item>
            </lk-col>
            <lk-col span="10" v-show="isColdChain && deliverInfo.deliveryMethod === 2 && deliverInfo.expressTime">
              <lk-form-item label="是否保险：">
                <div class="isInsurance-conent">
                  <lk-switch v-model="deliverInfo.isInsurance" @on-change="resetFreight" style="min-width: 45px; max-width: 45px">
                    <lk-icon type="md-checkmark" slot="open"></lk-icon>
                    <lk-icon type="md-close" slot="close"></lk-icon>
                  </lk-switch>
                  <div class="isInsurance-tip">开启后将自动购买配送保险,由顺丰赔偿可能的超温、损坏和丢失,需额外支付订单金额0.028%的运费</div>
                </div>
              </lk-form-item>
            </lk-col>
            <lk-col span="6" v-show="deliverInfo.deliveryMethod === 3">
              <lk-form-item label="配送公司：">
                <lk-input placeholder="请输入" v-model.trim="deliverInfo.company"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span="6" v-show="deliverInfo.deliveryMethod === 3">
              <lk-form-item label="配送单号：">
                <lk-input placeholder="请输入" v-model.trim="deliverInfo.code"></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row type="flex">
            <lk-col span="6">
              <lk-form-item label="发货人姓名：" prop="consignor">
                <lk-select placeholder="请选择" v-model="deliverInfo.consignor" :label='consignorLableName'
                  @on-change='handleUser' placement="top">
                  <lk-option v-for="(item) in  pharmacistList"  :key="item.id" :value='item.id'>
                  {{item.name+item.phone}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="发货人联系方式：" prop="consignorPhone">
                <lk-input placeholder="请输入" v-model.trim="deliverInfo.consignorPhone"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="发货城市：" prop="srcRegionList" ref="srcRegionList">
                <location v-model="deliverInfo.srcRegionList" :disabled="true" @on-change='resetFreight'></location>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="发货详细地址：" prop="consignAddress" ref="consignAddress">
                <lk-input placeholder="请输入详细地址" v-model.trim="deliverInfo.consignAddress" :maxlength="200" @on-blur='resetFreight'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row type="flex">
            <lk-col span="6">
              <lk-form-item label="收货人姓名：" prop="name">
                <lk-input v-model.trim="deliverInfo.name" placeholder="请输入收货人姓名"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="收货人联系方式：" prop="phone">
                <lk-input placeholder="请输入" v-model.trim="deliverInfo.phone"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="收货城市：" prop="descRegionList" ref="descRegionList">
                <location v-model="deliverInfo.descRegionList" @on-change='resetFreight'></location>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="收货详细地址：" prop="address" ref="address">
                <lk-input placeholder="请输入详细地址" v-model.trim="deliverInfo.address" :maxlength="200" @on-blur='resetFreight'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row type="flex" v-if="deliverInfo.deliveryMethod === 2">
            <lk-col span="2">
              <lk-button
                type="primary"
                @click='handlerBtnClick'
                :loading="btnLoading"
                style="margin: 0 0 20px 48px;"
              >
                <span v-if="!btnLoading">查询运费</span>
                <span v-else>查询中...</span>
              </lk-button>
            </lk-col>
            <lk-col span="6" v-if="showFreight">
              <lk-form-item label="配送渠道：" prop="transportSystemCode" ref="transportSystemCode">
                <lk-select
                  id="transportSelect"
                  v-model="deliverInfo.transportSystemCode"
                  @on-change='handlerSelectChange'
                  placement='top'
                >
                  <template v-if="transportList.length">
                    <lk-option value="transport" disabled>
                      <div class="selectTile">
                        <span
                          v-for="k in titleList"
                          :key="k"
                        >{{k}}</span>
                      </div>
                    </lk-option>
                      <lk-option
                        v-for="(item, index) in transportList"
                        :key='index'
                        :value="item.transportSystemCode"
                        :label="item.transportDesc"
                      >
                      <div class="selectTile">
                        <span>{{item.transportDesc}}</span>
                        <span>{{item.totalPrice}}</span>
                        <span>{{item.deliverTime}}</span>
                      </div>
                      </lk-option>
                  </template>
                </lk-select>
              </lk-form-item>
            </lk-col>
            <lk-col span="6" v-if="showFreight">
              <lk-form-item label="运费：">
                <span>{{freight}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span="6" v-if="showFreight">
              <lk-form-item label="预计送达时间：" prop="">
                <span>{{deliverTime || ''}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row type="flex" v-if="isColdChain  && deliverInfo.deliveryMethod && deliverInfo.deliveryMethod != 2">
            <lk-col span="6">
              <lk-form-item label="起运时间及温度：" prop="transStartTime">
                <span class="specItem">
                  <timeStampDatePicker v-model="deliverInfo.transStartTime"></timeStampDatePicker>
                  <numberInput size='default' type='canMinus' v-model="deliverInfo.temperatureStart" placeholder="请输入">
                    <span >℃</span>
                  </numberInput>
                </span>
              </lk-form-item>
            </lk-col>
            <lk-col span="6">
              <lk-form-item label="预计送达时间及温度：" prop="transEndTime"  >
                <span class="specItem">
                  <timeStampDatePicker v-model="deliverInfo.transEndTime"></timeStampDatePicker>
                  <numberInput size='default' type='canMinus' v-model="deliverInfo.temperatureEnd" placeholder="请输入">
                    <span >℃</span>
                  </numberInput>
                </span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </lk-card>
    </div>
    <paymentModal
      :isShowSfReceive="isSFMedicineDelivery&&isNeedUseUnifyExpress"
      :sfDisabled="isCanUseSFReceive"
      :sfDisabledText="isSfCityRush"
      :isOrderOfSF="isOrderOfSF"
      :delivery='isColdChain'
      v-model="showPayment"
      :isShow="!isNeedUseUnifyExpress"
      :showType='true'
      :orderInfo='orderInfo'
      :paidList='paidList'
      :update='false'
      @submitPay='handlePayment'
      :base='saleData'
      :patientInfo="patientInfo">
    </paymentModal>
  </div>
  </BaseFrame>
  <div class="bottomFix">
    <div class="pharmacistWrap"  v-if="saleData.salePrescription&&!notPrescription">
      <div class="pharmacistInfo">
        <label>药师审方:</label>
        <lk-input class="mr8 mWidth"  placeholder="药师账号" v-model="login.account"></lk-input>
        <lk-input  class="input-password mWidth" type='text' placeholder="密码"  v-model="login.password"></lk-input>
      </div>
      <div class="whetherPC" v-if="showPharmaceutics">
        <label>是否提供药学服务:</label>
        <lk-select v-model="saleData.pharmaceuticalStatus" class="pcSelect">
          <lk-option v-for='(item,i) in judgeList' :key="i" :value="+i">{{item}}</lk-option>
        </lk-select>
      </div>
    </div>
    <div class="btns">
      <!-- <lk-button class="mr8" >重置</lk-button> -->
      <lk-button type='primary' ref="end"  @click="validate" >去收款</lk-button>
    </div>
    <div class="fingerIdentifCon" v-if="isNeedUseFinger&&saleData.salePrescription&&!notPrescription">
      <lk-button type="primary" @click="toCheckFingerPrint">指纹审方</lk-button>
      <span style="margin-left:10px;width:40px">{{personFingerInfo.isPass ? '已通过' : '未通过'}}</span>
      <div v-if="personFingerInfo.isPass" style="display:flex;margin-left:10px">
        <div style="margin-right:10px">{{`药师名称:${personFingerInfo.name}`}}</div>
        <div>{{`药师证件号:${personFingerInfo.cardId}`}}</div>
      </div>
    </div>
  </div>
  <lk-modal
    v-model="modalFinger"
    title="指纹审方"
    :mask-closable='false'
    :footer-hide='true'>
    <div class="imgCon">
      <img :src="alertUrl" style="width:80px;height:80px">
      <p style="font-size:14px">请在指纹仪上识别指纹</p>
      <p>{{isIdentifying ? '识别中，请稍候...' : ''}}</p>
    </div>
  </lk-modal>
  <POSModal
    v-model="showDTPModal"
    :content="POSModalContent"
    content_title="未完成浦发POS收款的订单数超限,无法新建订单!"
    @handleCancel='showDTPModal=false'
    type="alert"
    :noCancel='true'
    :showCountDown='false'
    @confirm='showDTPModal=false'
    confirmText='知道了'
    ref="posModal"
  ></POSModal>
</div>
</template>
<script>
// import moment from 'moment';
import BaseFrame from '../../components/frame/BaseFrame.vue';
import PaymentModal from '../../components/sale/PaymentModal.vue';
import prescriptionCommon from '../../components/prescription/Common.vue';
import prescriptionDecoction from '../../components/prescription/Decoction.vue';
import GoodsTable from '../../components/sale/GoodsTable.vue';
import CredentialsInput from '../../components/CredentialsInput';
import sale from '../../services/sale';
import user from '../../services/user';
import system from '../../services/system';
import utils from '../../libs/utils';
import uniStoreInfo from '../../libs/storeUtil';
import finger from '../../libs/finger';
import alertImg from '../../assets/cashier/alert.svg';
import POSModal from '../../components/POSModal.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import location from '../../components/location.vue';

export default {
  name: 'prescriptionSale',
  components: {
    BaseFrame,
    prescriptionCommon,
    prescriptionDecoction,
    PaymentModal,
    GoodsTable,
    CredentialsInput,
    POSModal,
    timeStampDatePicker,
    location,
  },

  computed: {
    btnText() {
      const res = this.saleData && this.saleData.ep && [10, 13].indexOf(this.saleData.ep.sourceType) >= 0;
      const tempStr = this.isJD ? '京东' : '天猫';
      if (res === true) {
        return `查看${tempStr}后台订单`;
      }
      return '';
    },
    skipPictureCheck() {
      return this.$route.name == 'OTCOrderSale'; // otc创建订单不需要校验图片
    },
    isTmall() {
      return this.saleData && this.saleData.ep && [10, 13].indexOf(this.saleData.ep.sourceType) >= 0;
    },
    isJD() { // 只用于文案判断
      return this.saleData && this.saleData.ep && [13].indexOf(this.saleData.ep.sourceType) >= 0;
    },
    isMeiXin() {
      return this.saleData && this.saleData.ep && this.saleData.ep.sourceType === 12;
    },
    notPrescription() {
      return this.saleData.salePrescription && (this.saleData.salePrescription.type === 2 || this.saleData.salePrescription.type === 6);
    },
    patientInfo() {
      return {
        relatePatientName: this.saleData.salePrescription && this.saleData.salePrescription.patientName,
        relatePatientPhone: this.saleData.salePrescription && this.saleData.salePrescription.patientPhone,
      };
    },
    isAppletReservation() {
      return this.saleData.salePrescription.type === 5;
    },
    isNeedUseFinger() {
      return uniStoreInfo.isNeedUseFinger(this.$store.state.storeInfo.id);
    },
    deliveryMethodName() {
      try {
        const name = this.deliverList.filter(item => item.value === this.deliverInfo.deliveryMethod)[0].label;
        return name;
      } catch (error) {
        return '';
      }
    },
    consignorLableName() {
      try {
        const list = this.pharmacistList.filter(item => item.id === this.deliverInfo.consignor);
        return list[0].name + list[0].phone;
      } catch (error) {
        return null;
      }
    },
    showFreight() {
      return this.deliverInfo.deliveryMethod === 2 && this.showSfFreight;
    },
    isExpressOrder() { // 判断当前订单是否是配送订单
      return this.saleData.salePrescription && this.saleData.salePrescription.orderType === 2;
    },
    isNeedUseUnifyExpress() { // 是否使用统一的配送信息模块
      const sourceTypeArr = [
        0, // 0:药学服务
        2, // 2:互联网医院
        8, // 8:小程序预约
        9, // 9: 药联
        12, // 12: 镁信
      ];
      let currentSource;
      if (this.saleData.salePrescription) {
        currentSource = this.saleData.salePrescription.sourceType;
      }
      if (typeof currentSource === 'undefined') {
        currentSource = 0;
      }
      return sourceTypeArr.includes(currentSource);
    },
    isSelectOrderType() { // 药联订单展示顶部订单类型选择框
      const sourceList = [9]; // 9: 药联
      let currentSource;
      if (this.saleData.salePrescription) {
        currentSource = this.saleData.salePrescription.sourceType;
      }
      return sourceList.includes(currentSource);
    },
    isSFMedicineDelivery() { // 是否是顺丰医药配送方式
      return this.deliverInfo.deliveryMethod === 2;
    },
    isCanUseSFReceive() { // 是否可以开启顺丰代收
      const payStatus = this.saleData.salePrescription && this.saleData.salePrescription.paymentStatus; // 订单支付状态 paymentStatus 2:已支付 1:未支付
      if (payStatus === 1 && this.deliverInfo.transportSystemCode === 'SF-CITYRUSH') { // 如果是未支付并且是配送信息是顺丰同城或者顺丰闪送则可开启顺丰代收
        return false;
      }
      return true;
    },
    isSfCityRush() { // 配送渠道是否顺丰同城，展示不同提示文案
      switch (this.deliverInfo.transportSystemCode) {
        case 'SF-CITYRUSH':
          return this.SFCollectChannelMsg2;
        default:
          return this.SFCollectChannelMsg1;
      }
    },
    isOrderOfSF() {
      let isSF = false;
      switch (this.deliverInfo.deliveryMethod) {
        case 2:
          isSF = true;
          break;
        default:
          isSF = false;
      }
      return isSF;
    },
  },
  watch: {
    saleData: {
      handler(val) {
        if (val.saleOrderDetailList && val.saleOrderDetailList.length) {
          let needBuyerInfo = false;
          let goodsCount = 0;
          let payment = 0;
          const promoteGoodsQoList = this.handlerMatchParams(val.saleOrderDetailList);
          val.saleOrderDetailList.forEach((item) => {
            goodsCount += item.goodsCount;
            payment += (item.realPrice * item.goodsCount);
            if (item.types.includes('Ephedrine') || item.types.includes('ThirdEquipment')) {
              needBuyerInfo = true;
            }
          });
          const { saleExpress } = this.saleData;
          saleExpress.expressTime = saleExpress.expressTime || (new Date()).getTime();
          this.needBuyerInfo = needBuyerInfo;
          if (needBuyerInfo && !this.saleData.saleBuyerInfo) {
            this.saleData.saleBuyerInfo = {};
          }
          this.isDicount(promoteGoodsQoList, payment, goodsCount, saleExpress);
          this.orderInfo.type = val.salePrescription.orderType;
        } else {
          this.needBuyerInfo = false;
        }
      },
      deep: true,
    },
    'deliverInfo.deliveryMethod': {
      handler(val) {
        this.resetFreight();
        if (val === 2) {
          this.deliverInfoValidate = Object.assign({}, this.deliverInfoValidate, {
            srcRegionList: [
              {
                required: true, message: '请选择发货城市', trigger: 'change', type: 'array',
              },
            ],
            descRegionList: [
              {
                required: true, message: '请选择收货城市', trigger: 'change', type: 'array',
              },
            ],
            consignAddress: [
              { required: true, message: '请输入详细地址', trigger: 'change' },
            ],
            address: [
              { required: true, message: '请输入详细地址', trigger: 'change' },
            ],
          });
          this.$nextTick(() => {
            this.$refs.srcRegionList.isRequired = true;
            this.$refs.descRegionList.isRequired = true;
            this.$refs.consignAddress.isRequired = true;
            this.$refs.address.isRequired = true;
          });
        } else {
          this.$nextTick(() => {
            this.$refs.srcRegionList.isRequired = false;
            this.$refs.descRegionList.isRequired = false;
            this.$refs.consignAddress.isRequired = false;
            this.$refs.address.isRequired = false;
            this.deliverInfoValidate = Object.assign({}, this.deliverInfoValidate, {
              srcRegionList: [
                { required: false },
              ],
              descRegionList: [
                { required: false },
              ],
              consignAddress: [
                { required: false },
              ],
              address: [
                { required: false },
              ],
            });
          });
        }
      },
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请填写联系方式'));
      } else {
        const phone = [/^1[3465789]\d{9}$/, /^0\d{2,3}-?\d{7,8}$/, /^0\d{2,3}\s?\d{7,8}$/];
        let ifsuccess = false;
        phone.forEach((item, index) => {
          if (item.test(value)) {
            ifsuccess = true;
          }
        });
        ifsuccess ? callback() : callback(new Error('请输入手机号码或包含区号的固定电话号码'));
      }
    };
    return {
      showPharmaceutics: false,
      judgeList: {
        1: '是',
        2: '否',
      },
      isDisableOrderType: false,
      orderType: 2,
      pharmacistList: [],
      titleList: {
        1: '配送渠道',
        2: '运费',
        3: '预计送达时间',
      },
      SFCollectChannelMsg1: '顺丰标快配送渠道不支持使用代收',
      SFCollectChannelMsg2: '开启后将由SF配送人员在包裹送达时代收',
      btnLoading: false,
      transportList: [],
      deliverInfo: {
        deliveryMethod: null, // 配送方式
        code: null, // 配送单号
        company: '', // 配送公司
        consignor: null, // 发货人id，根据这个值给姓名和联系方式赋相应的值。
        consignorName: '', // 发货人姓名
        consignorPhone: '', // 发货人联系方式
        expressTime: null, // 发货时间
        srcRegionList: [], // 发货地
        consignAddress: '', // 发货详细地址
        name: '', // 收货人
        phone: '', // 收货人电话
        descRegionList: [], // 收货地
        address: '', // 收货详细地址
        transportSystemCode: '', // 配送渠道
        transStartTime: null, // 起运时间及温度
        transEndTime: null, // 预计送达时间及温度
        temperatureStart: null, // 起运温度
        temperatureEnd: null, // 到达温度
        isInsurance: false, // 是否保险
      },
      deliverInfoValidate: {
        deliveryMethod: [
          {
            required: true, message: '请选择配送方式', trigger: 'change', type: 'number',
          },
        ],
        transportSystemCode: [
          {
            required: true, message: '请选择配送渠道', trigger: 'change',
          },
        ],
        consignor: [
          {
            required: true, message: '请选择发货人姓名', trigger: 'change', type: 'number',
          },
        ],
        consignorPhone: [
          { required: true, validator: validatePhone, trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入收货人姓名', trigger: 'change' },
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'change' },
        ],
        expressTime: [
          {
            required: true, message: '请选择发货时间', trigger: 'change', type: 'date',
          },
        ],
      },
      deliverList: [
        {
          value: 1,
          label: '自配送',
        },
        {
          value: 3,
          label: '其他',
        },
      ],
      freight: 0,
      deliverTime: '',
      deliveryChannelName: '',
      transportList: [],
      showSfFreight: false,

      POSModalContent: '', // POSModal组件展示内容
      showDTPModal: false, // POSModal组件是否显示
      isPatientRebuy: false,
      submitPromoteSaleMatchVOS: [],
      fingerPort: 0, // 指纹仪端口号
      fingerPrint: '', // 用户指纹特征数据
      personFingerInfo: {
        isPass: false, // 是否已经指纹审方通过
        name: '',
        cardId: '',
      },
      isIdentifying: false,
      modalFinger: false,
      alertUrl: alertImg,
      limitedNumer: 100,
      ifCanEdit: '',
      isContainDataDirectGoods: '',
      saleBuyerInfo: null,
      isAid: false,
      isColdChain: false,
      login: {
        account: '',
        password: '',
      },
      needBuyerInfo: false,
      paidList: [],
      code: '',
      // totalReceive: 0,
      showPayment: false,
      // update: false,
      saleUsageList: [],
      paymentList: [],
      orderInfo: {
        goodsCount: 0,
        payment: 0,
        discount: 0,
        totalAmount: 0,
        saleExpress: {},
        type: 0,
        notOrigin: false,
        promoteDiscountVOList: [],
      },
      toPaymentList: [],
      infos: [],
      genderList: {
        1: '男',
        2: '女',
      },
      current: 0,
      loginPrescription: false,
      goodsCount: 0,
      goodsPage: 1,
      goodsSize: 10,
      orderId: '',
      payData: {
      	id: '', // 订单ID,
        type: '',

      },

      diseaseList: [],
      saleData: {
        saleOrder: {},
        saleExpress: {},
        saleOrderDetailList: [],
        saleBuyerInfo: {},
        salePrescription: null,
        // listSaleUsage: [],
      },
      // token: '',
      totalPayment: 0,
      noSame: false,
      token: '',
      errArr: [],
      epDetailPrice: {}, // 线上订单
      dataLink: false,
    };
  },
  methods: {
    handlerSelectChange(val) {
      if (val) {
        const filterList = this.transportList.filter(item => item.transportSystemCode == val);
        const {
          deliverTime,
          totalPrice,
          transportDesc,
        } = filterList[0];
        this.freight = totalPrice;
        this.deliverTime = deliverTime;
        this.deliveryChannelName = transportDesc;
      }
    },
    // eslint-disable-next-line func-names
    getExpressFee: _.debounce(function () {
      const srcAddress = {
        regionList: this.deliverInfo.srcRegionList,
        address: this.deliverInfo.consignAddress || '',
        name: this.deliverInfo.consignorName || '',
        phone: this.deliverInfo.consignorPhone || '',
      };
      const destAddress = {
        regionList: this.deliverInfo.descRegionList,
        address: this.deliverInfo.address || '',
        name: this.deliverInfo.name || '',
        phone: this.deliverInfo.phone || '',
      };
      const goodsDetail = [];
      this.saleData.saleOrderDetailList.forEach((item) => {
        goodsDetail.push({
          goodsStoreId: item.goodsStoreId,
          goodsCount: item.goodsCount,
        });
      });
      this.promoteTableData && this.promoteTableData.length && this.promoteTableData.forEach((item) => {
        goodsDetail.push({
          goodsStoreId: item.goodsStoreId,
          goodsCount: item.promoteNum,
        });
      });
      this.isColdChain = !!this.saleData.saleOrderDetailList.filter(item => item.isColdChain === 1).length;
      const params = {
        srcAddress,
        destAddress,
        goodsDetail,
        orderTotalAmount: Number(this.orderInfo.totalAmount || 0),
        isColdChain: this.isColdChain ? 1 : 2,
        isInsurance: this.deliverInfo.isInsurance ? 1 : 0,
      };
      sale.getExpressFee(params).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.success === '0') {
            this.$Modal.warning({
              title: '提示',
              content: `<p>${res.data.data.message}</p>`,
              okText: '确认',
            });
          } else {
            this.transportList = res.data.data.list;
            if (this.transportList.length) {
              this.showSfFreight = true;
              // this.handlerDefaultTransport();
            } else {
              this.$Message.warning('无有效配送渠道，请检查收发货地址是否填写错误');
            }
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
      this.btnLoading = false;
    }, 2000),
    handlerDefaultTransport() {
      this.showSfFreight = true;
      setTimeout(() => {
        const {
          transportSystemCode,
          price,
          deliverTime,
          transportDesc,
        } = this.transportList[0];
        this.deliverInfo.transportSystemCode = transportSystemCode;
        this.freight = price;
        this.deliveryChannelName = transportDesc;
        this.deliverTime = deliverTime;
        if (this.$refs.transportSystemCode && this.$refs.transportSystemCode.validateMessage && this.transportList.length) {
          this.$refs.transportSystemCode.validateMessage = '';
          this.$refs.transportSystemCode.validateState = '';
        }
      }, 200);
    },
    handlerBtnClick() {
      if (this.saleData.saleOrderDetailList && this.saleData.saleOrderDetailList.length) {
        this.validateDeliverInfo();
      } else {
        this.$Message.warning('请选择药品后查询运费');
      }
    },
    validateDeliverInfo() {
      if (this.deliverInfo.deliveryMethod === 2) { // 如果配送方式是顺丰医药
        this.freight = 0;
        const {
          deliveryMethod, consignorName, consignorPhone, name, phone, srcRegionList, descRegionList, consignAddress, address,
        } = this.deliverInfo;
        if (deliveryMethod && consignorName && consignorPhone && name && phone && srcRegionList.length && descRegionList.length && consignAddress && address) {
          if (utils.phoneValidator(consignorPhone) && utils.phoneValidator(phone)) {
            this.getExpressFee();
            this.btnLoading = true;
          } else {
            this.$Message.error('请检查联系方式是否正确');
          }
        } else {
          this.$Message.warning('请填写收发货信息后再查询');
        }
      }
    },
    resetFreight() {
      this.deliverInfo.transportSystemCode = '';
      this.freight = 0;
      this.deliverTime = '';
      this.deliveryChannelName = '';
      this.transportList = [];
      this.showSfFreight = false;
    },
    handleUser(val) {
      let temp = null;
      this.pharmacistList.forEach((item) => {
        if (item.id === val) {
          temp = item;
        }
      });
      this.deliverInfo.consignorPhone = temp.phone;
      this.deliverInfo.consignorName = temp.name;
    },
    toWatchBackTMOrder() {
      if (this.isJD) { // 京东
        window.open('https://shop.jd.com/jdm/home');
      } else { // 天猫
        window.open(`https://trade.tmall.com/detail/orderDetail.htm?spm=a1z09.1.0.0.11ec360632C4W3&bizOrderId=${this.saleData.salePrescription.onlineOrderCode}&sifg=1`);
      }
    },
    handlerPatientRebuy(goodsStoreId, patientRebuy) {
      if (patientRebuy) {
        this.isPatientRebuy = patientRebuy;
        this.saleData.salePrescription.saleUsageList.forEach((item) => {
          if (!item.isPatientRebuy && item.goodsStoreId === goodsStoreId) {
            item.isPatientRebuy = 1;
          }
        });
      }
    },
    handlerMatchParams(list) {
      const promoteGoodsQoList = [];
      list.forEach((item) => {
        if (JSON.stringify(item.inventoryInfo) != '{}') {
          const obj = {
            goodsStoreId: item.goodsStoreId,
            goodsNum: Number(item.num) || 0,
            minPkgUnit: item.minPkgUnitCode,
            batchCode: item.batchCode,
            realPrice: item.realPrice || 0,
            batchSeq: item.inventoryInfo.goodsBatchSeq,
            goodsBaseId: item.goodsBaseId,
            goodsName: item.approvedDrugNames,
            price: item.retailPrice || 0,
            serialCode: item.inventoryInfo.drugSerialCode,
          };
          promoteGoodsQoList.push(obj);
        }
      });
      return promoteGoodsQoList;
    },
    toCheckFingerPrint() {
      this.modalFinger = true;
      this.getFingerDeviceType();
    },
    getFingerDeviceType() {
      finger.get_device_type((res) => { // 0是usb连接，>0是串口，<0是失败
        if (res == 0 || res > 0) {
          this.fingerPort = res;
          this.getFeature(this.fingerPort);
        } else {
          this.$Message.error('无法检测到设备,请检测设备是否正确连接');
          this.modalFinger = false;
        }
      });
    },
    getFeature(fingerPort) {
      finger.get_feature(fingerPort, (res, data) => {
        this.isIdentifying = true;
        if ((res) == 0) {
          this.isIdentifying = false;
          this.fingerPrint = data;
          this.toUploadFingerPrint();
        } else {
          this.isIdentifying = false;
          this.$Message.error('指纹获取失败,请重试');
          this.modalFinger = false;
        }
      });
    },
    toUploadFingerPrint() {
      const params = {
        data: this.fingerPrint,
        orgCode: this.$store.state.storeInfo.code || '',
      };
      sale.verifyFingerprint(params).then((res) => {
        if (res.data.status === 200) {
          const { name, idcard } = res.data.data;
          this.personFingerInfo.name = name;
          this.personFingerInfo.cardId = idcard;
          this.personFingerInfo.isPass = true;
          this.$Message.success('指纹校验通过');
          this.modalFinger = false;
        } else {
          this.modalFinger = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleChange(e) {
      if (e && e.length) {
        let needBuyerInfo = false;
        let goodsCount = 0;
        let payment = 0;
        const promoteGoodsQoList = this.handlerMatchParams(e);
        e.forEach((item) => {
          goodsCount += item.goodsCount;
          payment += (item.realPrice * item.goodsCount);
          if (item.types.includes('Ephedrine') || item.types.includes('ThirdEquipment')) {
            needBuyerInfo = true;
          }
        });
        const { saleExpress } = this.saleData;

        if (needBuyerInfo && !this.saleData.saleBuyerInfo) {
          this.saleData.saleBuyerInfo = {};
        }
        this.needBuyerInfo = needBuyerInfo;
        this.isDicount(promoteGoodsQoList, payment, goodsCount, saleExpress);
        this.orderInfo.type = this.saleData.salePrescription.orderType;
      } else {
        this.needBuyerInfo = false;
      }
    },
    isDicount(promoteGoodsQoList, payment, goodsCount, saleExpress) {
      // promoteGoodsQoList促销商品请求参数
      if (!this.saleData.ep.sourceType && promoteGoodsQoList.length) { // 没有sourceType就是线下订单
        sale.promoteMatch({ promoteGoodsQoList }).then((res) => {
          this.submitPromoteSaleMatchVOS = [];
          if (res.data.status === 200) {
            if (res.data.data) {
              const result = res.data.data;
              const { amount, discount, receivable } = result;
              this.orderInfo.totalAmount = amount;
              this.orderInfo.payment = receivable;
              this.orderInfo.discount = discount;
              this.orderInfo.promoteDiscountVOList = result.promoteDiscountVOList || [];
              this.submitPromoteSaleMatchVOS = result.promoteSaleMatchVOS || [];
            } else {
              this.handlerDiscount(payment);
            }
          } else {
            this.handlerDiscount(payment);
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.handlerDiscount(payment);
      }
      this.orderInfo.goodsCount = goodsCount;
      this.orderInfo.saleExpress = saleExpress;
    },
    handlerDiscount(payment) {
      const discount = this.orderInfo.discount || null;
      this.orderInfo.totalAmount = payment;
      if (discount) {
        this.orderInfo.payment = payment - discount;
      } else {
        this.orderInfo.payment = payment;
      }
    },
    getpharmacistList() {
      return new Promise((resolve) => {
        system.storeUserList({
          page: 1,
          size: 1000,
          // roleId: 3,
          majorType: 1,
          statusCodeList: [1],

        }).then((res) => {
          if (res.data.status === 200) {
            // this.diseaseList = res.data.data;
            const list = [];
            res.data.data.list.forEach((item) => {
              list.push(item.sysUser); // 抽取sysUser
            });
            this.pharmacistList = list;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleValid() {
      const goodsKind = {};
      let noBatch = false;
      this.saleData.saleUsageList.forEach((item) => {
        goodsKind[item.goodsStoreId] = {};
        goodsKind[item.goodsStoreId].all = item.sameGoodsTotalNum;
        goodsKind[item.goodsStoreId].count = 0;
      });
      this.saleData.saleOrderDetailList.forEach((item) => {
        item.inventoryInfo.goodsBatchNumber || (noBatch = true);
        if (goodsKind[item.goodsStoreId]) {
          goodsKind[item.goodsStoreId].count += item.goodsCount;
        }
      });
      if (noBatch) {
        this.$Message.error('请选择批号');
        return false;
      }
      this.errArr = [];
      for (const key in goodsKind) {
        const el = utils.deepClone(goodsKind[key]);
        if (el.count !== el.all) {
          this.errArr.push(key);
        }
      }
      if (this.errArr.length) {
        this.$Message.error('销售商品数量填写有误，请查看修改');
        return false;
      }
      return true;
    },
    toValidateDeliveryInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.deliverInfo.validate((valid) => {
          resolve(valid);
        });
      });
    },
    async validate() {
      if (this.isNeedUseFinger && !this.personFingerInfo.isPass) {
        this.$Message.error('请先完成指纹审方');
        return;
      }
      if (!this.saleData.pharmaceuticalStatus && this.showPharmaceutics) {
        this.$Message.error('请选择是否提供药学服务');
        return;
      }
      if (!this.skipPictureCheck) {
        const picUrls = this.saleData.salePrescription.picUrls ? this.saleData.salePrescription.picUrls : [];
        let msg = '请上传处方图片';
        if (this.isTmall) {
          if (this.isJD) { // 临时这么处理
            msg = '请前往京东审方后台下载处方后上传图片';
          } else {
            msg = '请前往天猫审方后台下载处方后上传图片';
          }
        }
        if ((this.isAppletReservation || this.isTmall) && picUrls.length <= 0) {
          this.$Message.error(msg);
          return;
        }
      }
      if (this.isExpressOrder && this.isNeedUseUnifyExpress && this.orderType === 2) {
        if (this.isColdChain && this.deliverInfo.transStartTime > this.deliverInfo.transEndTime) {
          this.$Message.error('请填写正确运送时间');
          return;
        }
        if (this.freight === 0 && this.deliverInfo.deliveryMethod === 2) {
          this.$Message.error('顺丰医药配送需要查询运费并选择配送渠道');
          return;
        }
        const deliveryValid = await this.toValidateDeliveryInfo();
        if (!deliveryValid) {
          this.$Message.error('请填写配送信息');
          return;
        }
      }
      this.$refs.prescriptionInfo ? this.$refs.prescriptionInfo.validateForm().then((valid) => {
        if (valid) {
          this.getToken();
        } else {
          this.$Message.error('请按照要求填写');
        }
      }) : this.$refs.patientInfo1.validateForm().then((valid) => {
        if (valid) {
          this.getToken();
        } else {
          this.$Message.error('请完善处方登记内容');
        }
      });
    },
    getToken() {
      // this.showPayment = true;
      const toPay = () => {
        const { account, password } = this.login;
        if (!this.handleValid()) {
          return;
        }
        if (this.notPrescription) {
          this.showPayment = true;
          return;
        }
        if (!(account && password)) {
          this.$Message.error('请输入完整的药师信息');
          return;
        }
        this.token = '';
        this.isColdChain = !!this.saleData.saleOrderDetailList.filter(item => item.isColdChain === 1).length;
        user.loginToken(this.login).then((res) => {
          if (res.data.status === 200) {
            this.token = res.data.data;
            this.showPayment = true;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      };
      this.$refs.buyer ? this.$refs.buyer.validate((valid) => {
        if (valid) {
          toPay();
        } else {
          this.$Message.error('请填写正确的数据');
        }
      }) : toPay();
    },
    deleteItem(index) {
      this.saleData.saleOrderDetailList.splice(index, 1);
    },
    toUpdateElecPres(params) { // 更新关联电子处方状态
      return new Promise((resolve) => {
        sale.updateElecPrescription(params).then((res) => {
          if (res.data.status === 200) {
            resolve(true);
          } else {
            resolve(false);
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    async handlePayment(paymentList, infos, expressInfo, base, curPatientInfo, promotionInfo, receiveAmountList, specialCollection, isUseShunFengCollect) {
      const prescription = this.saleData.salePrescription;
      if (prescription && (prescription.isConnectElePre || prescription.isRelated === 1) && prescription.code && prescription.patientName) {
        const params = {
          code: prescription.code || '',
          patientName: prescription.patientName || '',
        };
        const res = await this.toUpdateElecPres(params);
        if (!res) {
          return;
        }
        this.saleData.salePrescription.isConnectElePre = false;
      }
      const temp = this.saleData;
      const { type } = infos;
      temp.saleOrder = {
        type,
        retailType: temp.salePrescription.retailType,
        relatePatientName: curPatientInfo.patientName,
        relatePatientPhone: curPatientInfo.patientPhone,
        contact: temp.salePrescription.contact || '',
        contactId: temp.salePrescription.contactId || '',
        contactPhone: temp.salePrescription.contactPhone || '',
      };
      if (this.isSelectOrderType) {
        temp.saleOrder.type = this.orderType;
      }
      if (isUseShunFengCollect) {
        temp.saleOrder.tag = 1; // tag是1表示顺丰代收，否则是3
      } else {
        temp.saleOrder.tag = 3;
      }
      let totalReceiveAmount = 0;
      if (receiveAmountList.length) {
        receiveAmountList.forEach((item) => {
          if (item.depositVerificationAmount) {
            totalReceiveAmount += item.depositVerificationAmount * 1;
          }
        });
      }
      const paymentListCopyed = utils.deepClone(paymentList);
      paymentListCopyed.push({
        proceedsTypeId: 6,
        proceedsTypeName: '预收款',
        amount: totalReceiveAmount,
      });
      receiveAmountList.forEach((item) => {
        item.financeDepositId = item.id;
        item.amount = item.depositVerificationAmount;
      });
      if (specialCollection && specialCollection.SPDBAmountList.amount) {
        temp.saleOrder.tag = 2;
        temp.saleOrder.receivablesAmount = specialCollection.SPDBAmountList.amount;
      }
      temp.saleOrder.totalAmount = this.orderInfo.totalAmount;
      temp.saleOrder.discount = this.orderInfo.discount;
      temp.financeDepositOrderList = receiveAmountList || [];
      temp.saleOrderProceedsList = paymentListCopyed;
      if (this.isExpressOrder && this.isNeedUseUnifyExpress) {
        temp.saleExpress = this.deliverInfo;
        temp.saleExpress.deliveryChannel = this.deliverInfo.transportSystemCode;
        temp.saleExpress.deliveryChannelName = this.deliveryChannelName;
        temp.saleExpress.deliveryTime = this.deliverTime;
        temp.saleExpress.freight = this.freight;
      } else {
        temp.saleExpress = expressInfo;
      }
      if (this.isColdChain) {
        temp.temperatureStart = this.deliverInfo.temperatureStart;
        temp.temperatureEnd = this.deliverInfo.temperatureEnd;
      }
      temp.saleExpress.isInsurance = this.deliverInfo.isInsurance ? 1 : 0;
      delete temp.salePrescription.sealUrl;
      delete temp.salePrescription.picUrl;
      // 如果是线下订单和线上订单在药学服务范围内的需要给后端传几个参数
      if (this.saleData.ep.pharmaceuticalStatus === 1 || !this.saleData.ep.sourceType) {
        temp.salePrescription.reviewer = this.saleData.ep.reviewer;
        temp.salePrescription.reviewerName = this.saleData.ep.reviewerName;
        temp.salePrescription.allocater = this.saleData.ep.allocater;
        temp.salePrescription.allocaterName = this.saleData.ep.allocaterName;
        temp.onlineOrderCode = temp.salePrescription.onlineOrderCode || '';
        const usageList = temp.usageList;
        temp.saleUsageList.forEach((item) => {
          usageList.forEach((subItem) => {
            if (item.goodsBaseId === subItem.goodsBaseId) {
              item.goodsUsageType = subItem.usageType;
              item.goodsDosage = subItem.dosage;
              item.goodsUsage = subItem.usageName;
              item.frequencyName = subItem.frequencyName;
              item.frequency = subItem.frequency;
              item.usageStartTime = subItem.startTime;
              item.medicationCycle = subItem.usageCycle;
              item.rebuyRemindDays = subItem.remindDays;
            }
          });
        });
      } else if (this.isTmall || this.isMeiXin) {
        // TODO：wxr预约单onlineOrderCode天猫入参未传
        temp.saleUsageList = temp.salePrescription.saleUsageList;
      } else {
        temp.salePrescription.allocater = utils.isMatchFilter(this.pharmacistList, temp.salePrescription.allocater);
        temp.salePrescription.reviewer = utils.isMatchFilter(this.pharmacistList, temp.salePrescription.reviewer);
        temp.salePrescription.allocater || (temp.salePrescription.allocaterName = '');
        temp.salePrescription.reviewer || (temp.salePrescription.reviewerName = '');
        temp.onlineOrderCode = temp.salePrescription.onlineOrderCode;
        this.pharmacistList.forEach((item) => {
          temp.salePrescription.reviewer === item.id && (temp.salePrescription.reviewerName = item.name);
          temp.salePrescription.allocater === item.id && (temp.salePrescription.allocaterName = item.name);
        });
      }
      paymentListCopyed.forEach((item) => {
        if (item.financeDepositId && item.amount) {
          temp.financeDepositId = item.financeDepositId;
          temp.verificationDeposit = item.amount;
        }
      });
      const promoteDiscountVOList = utils.deepClone(this.orderInfo.promoteDiscountVOList);
      if (promotionInfo.promotionDiscount) {
        const { promotionDiscount, promotionReason } = promotionInfo;
        const promotionItem = {
          cutPrice: promotionDiscount,
          remark: promotionReason,
        };
        promoteDiscountVOList.push(promotionItem);
      }
      temp.promoteDiscountVOList = promoteDiscountVOList;
      temp.promoteSaleMatchVOS = this.submitPromoteSaleMatchVOS;
      sale.createFromPrescription(this.token || '', temp).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('收款成功！');
          const {
            id,
            orderNo,
            tag,
            proceedsStatus,
          } = res.data.data;
          this.$router.push({
            name: this.isAid
              ? 'aidApplyList'
              : 'prescriptionList',
            params: {
              id, orderNo, tag, proceedsStatus,
            },
          });
        } else if (res.data.status === 80000) {
          this.showDTPModal = true;
          this.POSModalContent = res.data.error;
        } else {
          this.$Message.error(res.data.error);
        }
        this.showPayment = false;
      }).catch((err) => {
        this.showPayment = false;
        utils.handleError(err);
      });
    },
    getData(epId) {
      const reqFunc = this.isAid ? sale.getPrescriptionDetailAid : sale.getPrescriptiondDetail;
      reqFunc({ epId }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.saleData = data;
          const ep = data.ep;
          if (data.purchaser) {
            this.saleData.purchaser.deliveryMethod = ep.deliveryMethod || null;
          }
          this.saleData.salePrescription = ep;
          if (ep && ep.orderType) {
            this.orderType = ep.orderType;
            if (ep.orderType === 1) {
              this.isDisableOrderType = true;
            }
          }
          if (ep && ep.orderType === 2) {
            this.getExpressOrderInfos();
          }
          this.deliverInfo.name = ep.consigneeName || '';
          this.deliverInfo.phone = ep.consigneePhone || '';
          this.deliverInfo.address = ep.consigneeAddress || '';
          delete this.saleData.salePrescription.status;// 后端传输status会报错故删除
          this.saleData.epType = ep.type;
          this.saleData.salePrescription.epId = ep.id;
          this.orderInfo.discount = ep.totalDiscount || null;// 优惠金额
          if (ep.pharmaceuticalStatus) {
            this.showPharmaceutics = ep.pharmaceuticalStatus === 1;
          }
          this.orderInfo.pharmaceuticalStatus = ep.pharmaceuticalStatus || null;// 药师服务
          this.orderInfo.sourceType = ep.sourceType || 0;// 药师服务
          this.orderInfo.promoteDiscountVOList = data.promoteDiscountVOList || []; // 折扣信息
          this.paidList = data.epProceedsList;
          this.ifCanEdit = ep.isEdit;// 判断是否是纸质处方，true代表是，false代表否。
          this.isContainDataDirectGoods = data.isContainDdiGoods;
          const list = [];

          data.epDetailVoList.forEach((item) => {
            const result = item.epDetail;
            result.approvedDrugNames = item.approvedDrugNames;
            result.goodsName = item.goodsName;
            result.spec = item.spec;
            result.isRx = item.isRx || '';
            result.goodsCount = result.num;
            result.name = item.approvedDrugNames;
            result.inventoryInfo = {};
            result.drugMiniPackageUnit = result.minPkgUnitName;
            result.types = [];
            result.minPkgUnitCode = item.minPkgUnitCode;
            result.realPrice = result.realPrice;
            result.isRequired = true;
            result.isColdChain = item.isColdChain;
            result.inventoryEpFrozenList = item.inventoryEpFrozenList && item.inventoryEpFrozenList.length ? item.inventoryEpFrozenList : [];
            list.push(result);
            this.$set(this.epDetailPrice, result.goodsStoreId, result || []); // 创建订单药品单价从detail接口取，不从listGoodsById取了
          });
          this.saleData.saleUsageList = utils.deepClone(list);
          this.saleData.salePrescription.saleUsageList = utils.deepClone(list);
          this.saleData.saleOrderDetailList = utils.deepClone(list);
          this.saleData.saleExpress = {
            // code: this.saleData.salePrescription.code,
            address: this.saleData.salePrescription.consigneeAddress,
            SFPackagesNum: this.saleData.salePrescription.packagesNum,
            // company: this.saleData.salePrescription.code,
            phone: this.saleData.salePrescription.consigneePhone,
            name: this.saleData.salePrescription.consigneeName,
          };
          this.isColdChain = !!this.saleData.saleOrderDetailList.filter(item => item.isColdChain === 1).length;
          // TODO:wxr小程序预约只能上传图片，带过来的图片丢弃
          if (data.ep.type === 5) {
            this.$set(this.saleData.salePrescription, 'picUrls', []);
          }
          this.setUser();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    setUser() {
      const requiredCondition = this.saleData.salePrescription && this.saleData.salePrescription.retailType === 1;
      this.saleBuyerInfo = requiredCondition
        ? {
          buyerName: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
          buyerAge: [{
            required: true, message: '此处为必填项，不能为空。且为整数', trigger: 'blur', type: 'integer',
          },
          ],
          buyerGender: [{
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          }],
          buyerIdCard: [
            { required: true, validator: utils.validate.credentialsValidate, trigger: 'blur' },
            { required: true, message: '此处为必填项，不能为空。', trigger: 'blur' },
          // this.IdValidator,
          ],
          buyerReason: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
          buyerPhone: [
            { required: true, message: '此处为必填项，不能为空。', trigger: 'blur' },
            { validator: utils.validate.cellPhoneValidator, trigger: 'blur' },
          ],
        }

        : {
          buyerName: [{ required: true, message: '此处为必填项，不能为空。', trigger: 'blur' }],
          buyerIdCard: [
            { validator: utils.validate.credentialsValidate, trigger: 'blur' },
          // this.IdValidator,
          ],
          buyerPhone: [

            { required: false, validator: utils.validate.cellPhoneValidator, trigger: 'blur' },
          ],
        };
      this.saleBuyerInfo.buyerIdCard[0].isNoRequired = !requiredCondition;
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getExpressOrderInfos() { // 如果是配送订单的话，获取配送信息中的发货城市和发货地址信息
      const params = {
        storeId: this.$store.state.storeInfo.id,
      };
      sale.getExpressInfo(params).then((res) => {
        if (res.data.status === 200) {
          const {
            provinceId, cityId, countyId, address, sfYiyaoFlag,
          } = res.data.data;
          this.deliverInfo.srcRegionList = [provinceId, cityId, countyId];
          this.deliverInfo.descRegionList = [provinceId, cityId, countyId];
          const currentTime = Date.parse(new Date());
          this.deliverInfo.expressTime = currentTime;
          this.deliverInfo.consignAddress = address || '';
          if (sfYiyaoFlag && sfYiyaoFlag === 1) {
            this.deliverList.splice(1, 0, {
              value: 2,
              label: '顺丰医药',
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDataLink(e) {
      this.dataLink = e;
    },
    setRules(type) {
      this.saleBuyerInfo.buyerIdCard[0].credentialsType = type;
    },
  },
  created() {
    this.isAid = this.$route.name === 'aidSale';
    Promise.all([
      this.getpharmacistList(),
      this.getDiseaseList(),
    ]).then(() => {
      this.getData(this.$route.params.id, this.$route.params.patientId);
    });
  },
};
</script>
<style lang="less" scoped>
.selectTile {
  display: flex;
  span {
    width: 33%;
    text-align: center;
  }
  span:nth-child(2n-1) {
    text-align: left;
  }
}
.middleContainer{
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
    >div:first-child{
      margin-right: 8px
    }
}
.titleContainer{
  padding: 0 32px;
  background: #fff;
  height: 120px;
}
.header{
  display: flex;
  justify-content: space-between;
  height: 67px;
  line-height: 67px
}
.step{
  width: 50%
}
// .tableContainer,.content{
//   padding: 16px;
//   padding-bottom: 0px;
// }

.totalPay{
  font-size: 16px;
color: #1890FF;
}
.addContainer{
  // width: 836px;
  height: 300px;
  margin-bottom: 14px
}

.modalQuery{
  display: flex;
  label{
    width: 60px;
    line-height: 32px;
    font-size: 14px;
    color: rgba(0,0,0,0.75);
  }
}
.infos{
  .infosStr{
    >span{
      padding-right: 10px
    }
  }
}
.bottomFix{
  background: #fff;
  position: fixed;
  padding: 0 38px;
  bottom:0;
  width: calc(~'100% - 220px') ;
  border-top: 1px solid #eee;
  height: 60px;
  display: flex;
  z-index: 10;
  justify-content: flex-end;
  flex-wrap: nowrap;
  box-shadow: 0 0 8px #eee;
  .btns{
    width: 80px;
    height: 60px;
    line-height: 60px;
  >*{
    margin-left: 16px
  }
}
  .pharmacistWrap {
    display: flex;
    flex: 1;
    .pharmacistInfo{
      display: flex;
      align-items: center;
      height: 60px;
      line-height: 60px;
      margin-right: 10px;
      label{
        min-width: 62px;
      }
      label:before{
       content: '*';
        color: red;
        font-family: SimSun;
        margin-right: 4px
      }
      .mWidth {
        min-width: 90px;
      }
    }
    .whetherPC {
      display: flex;
      align-items: center;
      height: 60px;
      line-height: 60px;
      margin-left: 20px;
      .pcSelect {
        width: 80px;
      }
      label{
        min-width: 115px;
      }
      label:before {
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 12px;
        color: #ed4014;
      }
    }
  }

}

.isInsurance-conent {
  display: flex;
  align-items: center;
  position: relative;
  .isInsurance-tip {
    margin-left: 10px;
    line-height: initial;
    min-width: 310px;
  }
}
.imgCon {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fingerIdentifCon {
  display: flex;
  line-height: 60px;
  align-items: center;
}

#transportSelect /deep/ .ivu-select-dropdown {
  min-width: 330px !important;
}
</style>
